import { Navigate, Outlet } from 'react-router-dom';

import { LoadingOverlay } from '@mantine/core';

import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingOverlay visible data-testid="loading-overlay" />;
  }

  if (isAuthenticated) {
    if (user?.isNetworkPartner) {
      return <Navigate to="/bounce" replace />;
    }
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
}
